import { apiClient } from '@igs-web/common-utilities/api/api-client'

export const LegalRoutes = {
    electronicCommunicationConsent: () => apiClient.getDocPath('legal/Consent%20for%20Electronic%20Communications.pdf'),
    homeWarrantyServiceAgreement: () => apiClient.getDocPath('legal/ScanaHomeWarrantyServiceAgreement.pdf'),
}
